/**
 * Archivos de sistema (Windows / macOS / Linux) que se cuelan cuando el
 * usuario arrastra carpetas. No tienen valor de negocio y solo ensucian
 * la cola de upload. La comparación es case-insensitive porque Windows
 * no distingue mayúsculas.
 *
 * Mantener sincronizado con la lista de `documents/bulk_uploader.js`.
 */

const SYSTEM_FILE_NAMES = new Set([
  'desktop.ini',
  'thumbs.db',
  '.ds_store',
  '.localized',
  '.spotlight-v100',
  '.trashes',
  'icon\r',          // archivo "Icon" con CR de macOS
  '$recycle.bin',
]);

export const isSystemFile = (file) => {
  if (!file?.name) return false;
  return SYSTEM_FILE_NAMES.has(file.name.toLowerCase());
};

export default isSystemFile;
